<template>
  <div class="main-header centerimage" :style="'background-image: url(' + seleNav.poster + ')'">
    <div class="header-text">
      <div class="logo-img">
        <div class="ywdp"><span class="cur-p zwcolor">中文</span><span class="segmentation">|</span><span class="cur-p hoverColor" @click="switchEnglish">ENGLISH</span></div>
        <img @click="$router.push('/')"
          v-if="commonData.web_logo && commonData.web_logo.value"
          :src="commonData.web_logo.value" alt="logo">
      </div>
      <div class="header-info">
        <h1 class="title">{{seleNav.label_zh}}</h1>
        <p class="title-info to-3">{{seleNav.title}}</p>
      </div>
    </div>
    <div class="header-menu-bar">
      <div class="open-icon" @click="openMenu = true">
        <div><!-- icon --></div>
        <div><!-- icon --></div>
        <div><!-- icon --></div>
      </div>
      <div class="open-icon-close" v-if="openMenu">
        <a-icon type="close" @click="openMenu = false" />
      </div>
      <ul :class="{'open-ul' : openMenu}">
        <li
          v-for="(item, ind) in navList"
          :key="ind"
          v-show="item.label_zh !== '融英资讯'"
          :class="{'sele' : item.value === seleUrl}"
          @click="goToPage(item)">
          <span>{{item.label_zh}}</span>
        </li>
        <li class="skipStyle">
          <span class="cur-p">中文</span><span class="segmentation">|</span><span class="cur-p primary" @click="switchEnglish">ENGLISH</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: mapGetters([
    'commonData'
  ]),
  props: {
    backimgurl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    info: {
      type: String,
      default: ''
    },
    selected: {
      type: String,
      default: '/home'
    }
  },
  data () {
    return {
      openMenu: false,
      // 保存关于我们数据
      configData: [],
      // 关于我们查询状态
      readItemsLoading: false,
      // 当前选择导航
      seleUrl: '',
      // 导航列表
      navList: [],
      seleNav: {
        poster: ''
      }
    }
  },
  watch: {
    'commonData.web_pages' (obj) {
      this.navList = JSON.parse(obj.value)
      this.seleNav = this.navList.filter(item => item.value === this.seleUrl)[0]
      console.log(this.navList)
    },
    selected () {
      this.seleUrl = this.selected
    }
  },
  mounted () {
    this.seleUrl = this.selected
    if (this.commonData.web_comp_intro.value) {
      this.navList = JSON.parse(this.commonData.web_pages.value)
      this.seleNav = this.navList.filter(item => item.value === this.seleUrl)[0]
    }
  },
  methods: {
    switchEnglish () {
      window.location.href = 'https://www.rongyinglaw.com/en/#' + this.seleUrl
    },
    goToPage (e) {
      this.openMenu = false
      this.seleUrl = e.value
      this.$router.push(e.value)
      this.$emit('selected', e)
    }
  }
}
</script>

<style lang="less">
@import url('../utils/color.less');
@media screen and (max-width: 751px) and (min-width: 300px) {
  .example {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 140px 50px;
    margin: 20px 0;
  }
  .main-header {
    background-color: @primary;
    width: 100%;
    height: 340px;
    overflow: hidden;
    position: relative;
    .segmentation {
      padding-left: 10px;
      padding-right: 10px;
    }
    .skipStyle {
      padding-top: 36px !important;
    }
    .header-text {
      .ywdp {
        display: none;
      }
      .ywxp {
        font-family: Georgia, 宋体;
        position: absolute;
        left: 180px;
        top: -23px;
        width: 100px;
        padding-top: 20px;
        color: #fff;
        font-size: 18px;
        text-align: right;
        margin-right: 60px;
      }
      .logo-img {
        position: absolute;
        z-index: 2;
        left: 16px;
        top: 16px;
        img {
          width: 120px;
          height: 28px;
        }
      }
      .header-info {
        width: 100%;
        padding: 0 16px 40px;
        position: absolute;
        left: 0;
        bottom: 0;
        letter-spacing: 1px;
        font-family: Georgia, 宋体;
        color: #FFF;
        .title {
          font-size: 28px;
          color: #FFF;
          font-weight: bold;
          margin: 0 0 10px;
        }
        .title-info {
          font-size: 14px;
          color: #FFF;
          opacity: 0.6;
          margin: 0;
        }
      }
    }
    .header-menu-bar {
      .open-icon {
        width: 30px;
        position: absolute;
        z-index: 2;
        right: 16px;
        top: 16px;
        div {
          height: 4px;
          width: 100%;
          border-radius: 2px;
          margin-bottom: 5px;
          background-color: @support;
        }
      }
      .open-icon-close {
        position: absolute;
        z-index: 10;
        font-size: 16px;
        right: 22px;
        top: 16px;
      }
      ul {
        width: 200px;
        height: 100%;
        color: @silver;
        background-color: #FFF;
        font-size: 16px;
        padding: 60px 0 20px;
        position: absolute;
        z-index: 9;
        right: -200px;
        transition: 0.3s;
        -webkit-transition: 0.3s;
        margin: 0;
      }
      ul.open-ul {
        right: 0;
      }
      li {
        font-family: Georgia, 宋体;
        list-style-type: none;
        padding: 8px 0;
        text-align: center;
      }
      li.sele,
      li:hover {
        color: @primary;
        background: @primarylight;
      }
      li:hover {
        background: @op-primary02;
      }
    }
  }
}

@media screen and (min-width: 751px) {
  @width: 80%;
  .skipStyle {
    display: none !important;
  }
  .example {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 220px 50px;
    margin: 20px 0;
  }
  .main-header {
    background-color: @primary;
    .ywxp {
        display: none;
      }
    .ywdp {
      position: relative;
      top: 20px;
      font-family: Georgia, 宋体;
      color: #fff;
      font-size: 16px;
      text-align: right;
    }
    .zwcolor {
      color: rgba(255, 255, 255, 0.5) !important;
    }
    .hoverColor:hover {
      color: #DBA77F;
    }
    height: 500px;
    position: relative;
    .header-text {
      width: @width;
      max-width: 1400px;
      margin: auto;
      .logo-img {
        .segmentation {
          padding-left: 20px;
          padding-right: 20px;
        }
        padding: 30px 0;
        img {
          cursor: pointer;
          width: 200px;
          height: 44px;
        }
      }
      .header-info {
        width: 400px;
        margin-top: 40px;
        letter-spacing: 1px;
        font-family: Georgia, 宋体;
        color: #FFF;
        .title {
          font-size: 48px;
          color: #FFF;
          font-weight: bold;
          margin: 0 0 10px;
        }
        .title-info {
          line-height: 28px;
          color: #FFF;
          opacity: 0.6;
          margin: 0;
        }
      }
    }
    .header-menu-bar {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top: 1px solid rgba(255,255,255,0.2);
      .open-icon-close {
        display: none;
      }
      ul {
        width: @width;
        max-width: 1400px;
        margin: auto;
        margin-top: -1px;
      }
      li {
        display: inline-block;
        font-family: Georgia, 宋体;
        width: 120px;
        list-style-type: none;
        padding: 26px 0;
        text-align: center;
        font-size: 16px;
        color: rgba(255,255,255,0.7);
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
      }
      li.sele,
      li:hover {
        color: #DBA77F;
        background-color: rgba(255,255,255,0.1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/header.vue